import { memo, useCallback, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Box, Typography } from '@mui/material'

import { useStores } from 'stores/utils/hooks/useStores'
import PathDateInput from 'components/PathDateInput'
import { PrefillErrorKind } from 'stores/PrefillStore'
import { Error } from './Error'
import {
  getRemainingDobAuthAttempts,
  subscribePrefillStatus,
  trackPinCheck
} from './utils'

export const DOB_LENGTH = 10 // dd.mm.yyyy

const VerifyDob = observer(() => {
  const {
    prefill: {
      setDob,
      isError,
      setIsError,
      isDobVerified,
      setErrorKind,
      isDobInvalid
    },
    traversal: {
      data: {
        debtors: {
          primary: {
            personal: { firstname, lastname }
          }
        }
      }
    }
  } = useStores()

  useEffect(() => {
    trackPinCheck('success')
  }, [])

  const [remainingAttempts, setRemainingAttempts] = useState(
    getRemainingDobAuthAttempts()
  )

  useEffect(() => {
    const unsubscribe = subscribePrefillStatus(() => {
      setRemainingAttempts(getRemainingDobAuthAttempts())
    })
    return unsubscribe
  }, [])

  useEffect(() => {
    if (remainingAttempts === 0 && !isDobVerified) {
      setIsError(true)
      setErrorKind(PrefillErrorKind.MAX_ATTEMPTS)
    }
  }, [remainingAttempts, setErrorKind, setIsError])

  const handleDobChange = useCallback(
    (newDob: string | undefined, _raw?: string | number) => {
      if (typeof newDob === 'string') {
        setDob(newDob)
      }
      if (typeof newDob === 'undefined') {
        setDob('')
      }
    },
    [setDob]
  )

  const inputError = isDobInvalid
    ? `<strong>Ihre Eingabe war nicht erfolgreich.</strong> Bitte versuchen Sie es noch einmal im <strong>Format TT.MM.JJJJ</strong>.`
    : undefined

  if (isError) {
    return <Error />
  }

  return (
    <Box>
      <Typography variant="h3" color="primary" textAlign="center" mb={2}>
        {`Willkommen zurück ${firstname} ${lastname}!`}
      </Typography>

      <Typography variant="body1" component="p" mb={3}>
        Um mit Ihrem Kreditvergleich fortfahren zu können, benötigen wir Ihr
        Geburtsdatum.
      </Typography>

      <PathDateInput
        path="prefill.verifyDob"
        showTooltipOnFieldClick
        isTooltipHidden
        labelProp={'Geburtsdatum'}
        placeholder="DD.MM.JJJJ"
        onChange={handleDobChange}
        inputError={inputError}
        patch={false}
      />
    </Box>
  )
})

export default memo(VerifyDob)
